module.exports = __webpack_public_path__ + "static/media/YINYON.bde7d85a.jpg";